import { render, staticRenderFns } from "./ManualMatchIndicator.vue?vue&type=template&id=66af6cd2&scoped=true&"
import script from "./ManualMatchIndicator.vue?vue&type=script&lang=js&"
export * from "./ManualMatchIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ManualMatchIndicator.vue?vue&type=style&index=0&id=66af6cd2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af6cd2",
  null
  
)

export default component.exports